// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3euML","colMin":"styles_colMin__3olJ_","colCheckbox":"styles_colCheckbox__mxT1L"};